const iconData = require("./generateIcons");

module.exports = (() => {
  console.log("Welcome to design-system-data!");
  // console.log(iconData);
})();
